import { forwardRef, type SVGProps } from 'react';

export type TextIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const TextIcon = forwardRef<SVGSVGElement, TextIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 20 20">
    <path
      d="M15.498 6.244a.692.692 0 0 1-1.383 0V5.133H10.69v9.734h.811a.691.691 0 0 1 0 1.383H8.496a.691.691 0 0 1 0-1.383h.812V5.133H5.883v1.412a.691.691 0 0 1-1.383 0V5.042c0-.713.579-1.292 1.292-1.292h8.413c.714 0 1.293.579 1.293 1.292z"
      fill="currentColor"
    />
  </svg>
));

TextIcon.displayName = 'TextIcon';
